/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface McpConsentDetailResponse
 */
export interface McpConsentDetailResponse {
    /**
     * 
     * @type {string}
     * @memberof McpConsentDetailResponse
     */
    clientId: string;
    /**
     * 
     * @type {string}
     * @memberof McpConsentDetailResponse
     */
    clientName: string;
    /**
     * 
     * @type {string}
     * @memberof McpConsentDetailResponse
     */
    resource: string;
    /**
     * 
     * @type {McpConsentDetailResponseScopeEnum}
     * @memberof McpConsentDetailResponse
     */
    scope: McpConsentDetailResponseScopeEnum;
    /**
     * 
     * @type {Date}
     * @memberof McpConsentDetailResponse
     */
    expiresAt: Date;
    /**
     * 
     * @type {McpConsentDetailResponseAccessScopeEnum}
     * @memberof McpConsentDetailResponse
     */
    accessScope: McpConsentDetailResponseAccessScopeEnum;
    /**
     * 
     * @type {McpConsentDetailResponseRevocationScopeEnum}
     * @memberof McpConsentDetailResponse
     */
    revocationScope: McpConsentDetailResponseRevocationScopeEnum;
    /**
     * 
     * @type {McpConsentDetailResponseAccessModeEnum}
     * @memberof McpConsentDetailResponse
     */
    accessMode: McpConsentDetailResponseAccessModeEnum;
    /**
     * 
     * @type {number}
     * @memberof McpConsentDetailResponse
     */
    currentEligibleProjectCount: number;
    /**
     * 
     * @type {Array<string>}
     * @memberof McpConsentDetailResponse
     */
    currentEligibleProjectNames: Array<string>;
    /**
     * 
     * @type {number}
     * @memberof McpConsentDetailResponse
     */
    remainingEligibleProjectCount: number;
}


/**
 * @export
 */
export const McpConsentDetailResponseScopeEnum = {
    McpRead: 'mcp:read'
} as const;
export type McpConsentDetailResponseScopeEnum = typeof McpConsentDetailResponseScopeEnum[keyof typeof McpConsentDetailResponseScopeEnum];

/**
 * @export
 */
export const McpConsentDetailResponseAccessScopeEnum = {
    AllCurrentAndFutureEligibleProjects: 'all_current_and_future_eligible_projects'
} as const;
export type McpConsentDetailResponseAccessScopeEnum = typeof McpConsentDetailResponseAccessScopeEnum[keyof typeof McpConsentDetailResponseAccessScopeEnum];

/**
 * @export
 */
export const McpConsentDetailResponseRevocationScopeEnum = {
    EntireAccountConnection: 'entire_account_connection'
} as const;
export type McpConsentDetailResponseRevocationScopeEnum = typeof McpConsentDetailResponseRevocationScopeEnum[keyof typeof McpConsentDetailResponseRevocationScopeEnum];

/**
 * @export
 */
export const McpConsentDetailResponseAccessModeEnum = {
    Ordinary: 'ordinary',
    Superadmin: 'superadmin'
} as const;
export type McpConsentDetailResponseAccessModeEnum = typeof McpConsentDetailResponseAccessModeEnum[keyof typeof McpConsentDetailResponseAccessModeEnum];


/**
 * Check if a given object implements the McpConsentDetailResponse interface.
 */
export function instanceOfMcpConsentDetailResponse(value: object): value is McpConsentDetailResponse {
    if (!('clientId' in value) || value['clientId'] === undefined) return false;
    if (!('clientName' in value) || value['clientName'] === undefined) return false;
    if (!('resource' in value) || value['resource'] === undefined) return false;
    if (!('scope' in value) || value['scope'] === undefined) return false;
    if (value['scope'] !== 'mcp:read') return false;
    
    if (!('expiresAt' in value) || value['expiresAt'] === undefined) return false;
    if (!('accessScope' in value) || value['accessScope'] === undefined) return false;
    if (value['accessScope'] !== 'all_current_and_future_eligible_projects') return false;
    
    if (!('revocationScope' in value) || value['revocationScope'] === undefined) return false;
    if (value['revocationScope'] !== 'entire_account_connection') return false;
    
    if (!('accessMode' in value) || value['accessMode'] === undefined) return false;
    if (!('currentEligibleProjectCount' in value) || value['currentEligibleProjectCount'] === undefined) return false;
    if (!('currentEligibleProjectNames' in value) || value['currentEligibleProjectNames'] === undefined) return false;
    if (!('remainingEligibleProjectCount' in value) || value['remainingEligibleProjectCount'] === undefined) return false;
    return true;
}

export function McpConsentDetailResponseFromJSON(json: any): McpConsentDetailResponse {
    return McpConsentDetailResponseFromJSONTyped(json, false);
}

export function McpConsentDetailResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): McpConsentDetailResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'clientId': json['clientId'],
        'clientName': json['clientName'],
        'resource': json['resource'],
        'scope': json['scope'],
        'expiresAt': (new Date(json['expiresAt'])),
        'accessScope': json['accessScope'],
        'revocationScope': json['revocationScope'],
        'accessMode': json['accessMode'],
        'currentEligibleProjectCount': json['currentEligibleProjectCount'],
        'currentEligibleProjectNames': json['currentEligibleProjectNames'],
        'remainingEligibleProjectCount': json['remainingEligibleProjectCount'],
    };
}

export function McpConsentDetailResponseToJSON(json: any): McpConsentDetailResponse {
    return McpConsentDetailResponseToJSONTyped(json, false);
}

export function McpConsentDetailResponseToJSONTyped(value?: McpConsentDetailResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'clientId': value['clientId'],
        'clientName': value['clientName'],
        'resource': value['resource'],
        'scope': value['scope'],
        'expiresAt': value['expiresAt'].toISOString(),
        'accessScope': value['accessScope'],
        'revocationScope': value['revocationScope'],
        'accessMode': value['accessMode'],
        'currentEligibleProjectCount': value['currentEligibleProjectCount'],
        'currentEligibleProjectNames': value['currentEligibleProjectNames'],
        'remainingEligibleProjectCount': value['remainingEligibleProjectCount'],
    };
}

